var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 13.999,
    viewBox: "0 0 18 13.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "eye-solid_1_",
    "data-name": "eye-solid (1)",
    d: "M9.023,32a8.793,8.793,0,0,0-6.018,2.519,12.381,12.381,0,0,0-2.9,4.1.994.994,0,0,0,0,.769,12.381,12.381,0,0,0,2.9,4.1A8.793,8.793,0,0,0,9.023,46a8.793,8.793,0,0,0,6.018-2.519,12.475,12.475,0,0,0,2.906-4.1.994.994,0,0,0,0-.769,12.443,12.443,0,0,0-2.906-4.1A8.793,8.793,0,0,0,9.023,32Zm4.5,7a4.5,4.5,0,1,1-4.5-4.5A4.5,4.5,0,0,1,13.523,39Zm-4.5-2a2,2,0,0,1-2,2,1.959,1.959,0,0,1-.987-.262c-.006.087-.012.172-.012.262a3,3,0,1,0,3-3,2.46,2.46,0,0,0-.262.012A1.991,1.991,0,0,1,9.023,37Z",
    transform: "translate(-0.025 -32)",
    fill: "#146f62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSolid);
export default __webpack_public_path__ + "static/media/eye-solid.5ac2e9b87c7e4f0a7162fef8e1137ecc.svg";
export { ForwardRef as ReactComponent };